<!-- <section class="step-three showLogin">
  <div class="close-box pointer logo mar-bot-20">
    <img src="https://images.poshvine.com/logos/mastercard_logo.png" class="img-fluid login-client-logo">
  </div>
  <form [formGroup]="addCardForm" (submit)="addCardFormSubmit()">
    <div class="title">
      Enter first 8 digits of your card number
    </div>



    <div class="card-block">

      <label>Card number</label>
      <div class="flex main-flex">
        <div class="flex-3 pd-r7">
          <input type="text" #firstFocusable id="first_four_card_digits" class="form-control"
            (keyup)="onKeyph($event); keytab($event, focusable);checkbtn()" formControlName="binFirst4"
            autocomplete="off" minlength="4" maxlength="4" required>
        </div>
        <div class="flex-3 pd-l7">
          <input type="text" #focusable id="last_four_card_digits" class="form-control" formControlName="binLast4"
            autocomplete="off" minlength="4" maxlength="4"
            (keyup)="onKeyph($event);backkeytab($event, firstFocusable);checkbtn()" required>
        </div>
        <div class="flex-3 pd-r7">
          <div class="form-single-container">
            <input type="text" class="form-control text-center disabled" placeholder="XXXX" autocomplete="none"
              disabled>
          </div>
        </div>
        <div class="flex-3 pd-r7">
          <div class="form-single-container">
            <input type="text" class="form-control text-center disabled" (keyup)="onKeyph($event)"
              placeholder="XXXX" disabled>
          </div>
        </div>

      </div>
    </div>

    <div class="modal-foot mar-bot-50 pad-bot-20 clearfix">
      <div class="error-txt fnt-12 f500 pad-top-10" *ngIf="binError">
        <span>Please enter a valid Mastercard number</span>
      </div>

      <button class="btn btn-theme " *ngIf="!btnActive" type="submit" disabled="disabled">Continue</button>
      <button class="btn btn-theme relative" *ngIf="btnActive" type="submit"
        >Continue <div class="small-loader input-load merged-card-loader" *ngIf="isload2"></div></button>



    </div>
    <div class="flex last-b">
      <div class="ll">Your Card/ Account parameters are used only to check eligibility and are encrypted</div>
      <div class="rr">
        <img src="https://images.poshvine.com/logos/PCI-DSS-PoshVine.png">
      </div>

    </div>
  </form>
</section> -->


<div>
  <div class="modal-content">
    <div class="close-box pointer logo mar-bot-25 flex space-between align-center">
      <img src="https://images.poshvine.com/logos/mastercard_logo.png" class="img-fluid login-client-logo">
      <svg (click) = "closeModalRef()" class="c-icon" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.9309 1.89109L15.2749 0.246094L8.70957 6.76776L2.14428 0.246094L0.488281 1.89109L7.05357 8.41276L0.488281 14.9344L2.14428 16.5794L8.70957 10.0578L15.2749 16.5794L16.9309 14.9344L10.3656 8.41276L16.9309 1.89109Z" fill="#ADB5BD"/>
      </svg>
    </div>
    <section class="step-three">
      <form [formGroup]="addCardForm" (submit)="addCardFormSubmit()">
        <div class="title f600 fnt-22">Validate your details</div>

        <div class="card-block pad-top-15">
          <label class="mar-bot-20 fnt-16 lbl">Enter first 8 digits of your card number</label>
          <div class="card-lbl fnt-16 mar-bot-10 ">Card number</div>
          <div class="card-block">


            <div class="flex main-flex">
              <div class="flex-3 pd-r7">
                <input type="text" #firstFocusable id="first_four_card_digits" class="form-control"
                  (keyup)="onKeyph($event); keytab($event, focusable)" formControlName="binFirst4"
                  autocomplete="new-password" minlength="4" maxlength="4" (input)="checkbtn()" required>
              </div>
              <div class="flex-3 pd-l7">
                <input type="text" #focusable id="last_four_card_digits" class="form-control" formControlName="binLast4"
                  autocomplete="new-password" minlength="4" maxlength="4"
                  (keyup)="onKeyph($event);backkeytab($event, firstFocusable)" (input)="checkbtn()" required>
              </div>
              <div class="flex-3 pd-r7">
                <div class="form-single-container">
                  <input type="text" class="form-control text-center disabled" placeholder="XXXX" autocomplete="none"
                    disabled>
                </div>
              </div>
              <div class="flex-3 pd-r7">
                <div class="form-single-container">
                  <input type="text" class="form-control text-center disabled" (keyup)="onKeyph($event)"
                    placeholder="XXXX" disabled>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class=" pad-bot-20 clearfix">
          <div class="error-txt fnt-12 f500 pad-top-10" *ngIf="binError">
            <span>Dear customer, please re-check the first 8 digits of the card number you have entered</span>
          </div>


          <div class = "continue-btn-block">
            <button class="btn btn-theme " *ngIf="!btnActive" type="submit" disabled="disabled">Continue</button>
            <button class="btn btn-theme relative" *ngIf="btnActive" type="submit">Continue
              <div class="small-loader input-load card-loader" *ngIf="isload2"></div>
            </button>
          </div>

        </div>
        <div class="flex last-b">
          <div class="ll">Your Card/ Account parameters are used only to check eligibility and are encrypted</div>
          <div class="rr">
            <img src="https://images.poshvine.com/logos/PCI-DSS-PoshVine.png">
          </div>

        </div>
      </form>
    </section>


  </div>
</div>
